import { v4 as uuidv4 } from "uuid";

const dataSlider = [
  {
    id: uuidv4(),
    title: "We’re socially celebrated",
    subTitle: "Lorem"
  },
  {
    id: uuidv4(),
    title: "Ready to serve 40+ States",
    subTitle: "Lorem"
  },
  {
    id: uuidv4(),
    title: "Bikes maintained so good ",
    subTitle: "Lorem"
  }
];

export default dataSlider;
